module.exports = __webpack_public_path__ + "static/automatic-ai_2-dc4f368b860b278eb0a88bf96ada3837.jpg";